import React from "react";
import { ArrowLeftOutlined } from "@ant-design/icons";

export default function ManageJobsInvitedHeader({
  title,
  subtitle,
  contextLabel,
  countLabel,
  onBack,
  action,
}) {
  return (
    <header className="manage-jobs-invited-page__header">
      <div className="manage-jobs-invited-page__header-copy">
        {onBack ? (
          <button
            type="button"
            className="manage-jobs-invited-page__back-btn"
            onClick={onBack}
          >
            <ArrowLeftOutlined />
            Back to Manage Jobs
          </button>
        ) : null}

        <div className="manage-jobs-invited-page__title-row">
          <h1 className="manage-jobs-invited-page__title">{title}</h1>
          {countLabel ? (
            <span className="manage-jobs-invited-page__count-pill">{countLabel}</span>
          ) : null}
        </div>

        {contextLabel ? (
          <div className="manage-jobs-invited-page__context-chip">{contextLabel}</div>
        ) : null}
        <p className="manage-jobs-invited-page__subtitle">{subtitle}</p>
      </div>

      {action ? <div className="manage-jobs-invited-page__header-action">{action}</div> : null}
    </header>
  );
}
